<!--<div class='mt-6 flex flex-col md:flex-row md:items-start' *ngIf='(supplierService.entity$ | async) as entity'>-->
<!--    <div class='flex-auto'>-->
<!--        <div class='card'>-->
<!--            <div class='px-gutter py-4 border-b' fxLayout='row' fxLayoutAlign='space-between center'>-->
<!--                <h2 class='title m-0'>Détails</h2>-->
<!--                <ng-container *ngIf="!this.isInternSupplier">-->
<!--                    <button color='primary' mat-raised-button type='button' (click)='updateItem()'-->
<!--                            *hasPermission="[ENUM_PERMISSION.UPDATE_SUPPLIER]">MODIFIER-->
<!--                    </button>-->
<!--                </ng-container>-->
<!--            </div>-->
<!--            <div *ngIf='entity._id; else loading' class='px-gutter py-4' gdColumns='1fr 1fr' gdColumns.xs='1fr'-->
<!--                 gdGap='16px'>-->
<!--                <div class='py-3' fxLayout='row' fxLayoutAlign='start center'>-->
<!--                    <div @fadeInRight>-->
<!--                        <p class='m-0 body-1'>{{ entity.label }}</p>-->
<!--                        <p class='m-0 caption text-hint'>Dénomination</p>-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div class='py-3' fxLayout='row' fxLayoutAlign='start center'>-->

<!--                    <div @fadeInRight>-->
<!--                        <p class='m-0 body-1'>{{ entity.type | titlecase }}</p>-->
<!--                        <p class='m-0 caption text-hint'>Type</p>-->
<!--                    </div>-->
<!--                </div>-->

<!--                <ng-container *ngIf='entity.type === SupplierType.EXTERNE'>-->
<!--                    <div class='py-3' fxLayout='row' fxLayoutAlign='start center'>-->

<!--                        <div @fadeInRight>-->
<!--                            <p class='m-0 body-1'>{{ entity.tva }}</p>-->
<!--                            <p class='m-0 caption text-hint'>Numéro de TVA</p>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <details-line-base-->
<!--                            [label]='entity.subsidiarAccount'-->
<!--                            hint='Compte auxiliaire comptable'-->
<!--                    >-->
<!--                    </details-line-base>-->
<!--                </ng-container>-->

<!--                <ng-container-->
<!--                        *ngIf='entity.type === SupplierType.EXTERNE && entity.headquarterAddress.country !== "France"'>-->
<!--                    <div class='py-3' fxLayout='row' fxLayoutAlign='start center'>-->

<!--                        <div @fadeInRight>-->
<!--                            <p class='m-0 body-1'>{{ entity.dunsNumber }}</p>-->
<!--                            <p class='m-0 caption text-hint'>Identifiant entreprise</p>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </ng-container>-->

<!--                <ng-container-->
<!--                        *ngIf='(entity.type === SupplierType.EXTERNE && entity.headquarterAddress.country === "France")-->
<!--                        || (entity.supportEstablishment && entity.headquarterAddress.country === "France")'>-->
<!--                    <div class='py-3' fxLayout='row' fxLayoutAlign='start center'>-->

<!--                        <div @fadeInRight>-->
<!--                            <p class='m-0 body-1'>{{ entity.siretNumber }}</p>-->
<!--                            <p class='m-0 caption text-hint'>Numéro de siret</p>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class='py-3' fxLayout='row' fxLayoutAlign='start center'>-->

<!--                        <div @fadeInRight>-->
<!--                            <p class='m-0 body-1'>{{ entity.sirenNumber }}</p>-->
<!--                            <p class='m-0 caption text-hint'>Numéro de siren</p>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class='py-3' fxLayout='row' fxLayoutAlign='start center'>-->

<!--                        <div @fadeInRight>-->
<!--                            <p class='m-0 body-1'>{{ entity.codeApe }}</p>-->
<!--                            <p class='m-0 caption text-hint'>Code APE</p>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <ng-container *ngIf="entity.supportEstablishment">-->
<!--                        <div class='py-3' fxLayout='row' fxLayoutAlign='start center'>-->

<!--                            <details-line-base-->
<!--                                    hint="Établissement support lié"-->
<!--                                    [label]="entity.supportEstablishment.technicalIdentifier"-->
<!--                                    [linkPermission]="ENUM_PERMISSION.READ_SUPPLIER"-->
<!--                                    [link]="'/management/establishment/' + entity.supportEstablishment._id">-->
<!--                            </details-line-base>-->

<!--                        </div>-->
<!--                    </ng-container>-->
<!--                </ng-container>-->
<!--            </div>-->

<!--            <ng-container *ngIf='entity.type === SupplierType.EXTERNE  || entity.supportEstablishment'>-->
<!--                <div class='px-gutter py-4 border-b' fxLayout='row' fxLayoutAlign='space-between center'>-->
<!--                    <h2 class='title m-0'>Adresse SIRET fournisseur</h2>-->
<!--                </div>-->
<!--                <div *ngIf='entity._id; else loading' class='px-gutter py-4' gdColumns='1fr 1fr' gdColumns.xs='1fr'-->
<!--                     gdGap='16px'>-->
<!--                    <div class='py-3' fxLayout='row' fxLayoutAlign='start center'>-->
<!--                        <div @fadeInRight>-->
<!--                            <p class='m-0 body-1'>{{ entity.headquarterAddress.street }}</p>-->
<!--                            <p class='m-0 caption text-hint'>Adresse</p>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class='py-3' fxLayout='row' fxLayoutAlign='start center'>-->
<!--                        <div @fadeInRight>-->
<!--                            <p class='m-0 body-1'>{{ entity.headquarterAddress.additionalAddress }}</p>-->
<!--                            <p class='m-0 caption text-hint'>Complément d'adresse</p>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class='py-3' fxLayout='row' fxLayoutAlign='start center'>-->
<!--                        <div @fadeInRight>-->
<!--                            <p class='m-0 body-1'>{{ entity.headquarterAddress.postalCode }}</p>-->
<!--                            <p class='m-0 caption text-hint'>Code postal</p>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class='py-3' fxLayout='row' fxLayoutAlign='start center'>-->
<!--                        <div @fadeInRight>-->
<!--                            <p class='m-0 body-1'>{{ entity.headquarterAddress.city }}</p>-->
<!--                            <p class='m-0 caption text-hint'>Ville</p>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class='py-3' fxLayout='row' fxLayoutAlign='start center'>-->
<!--                        <div @fadeInRight>-->
<!--                            <p class='m-0 body-1'>{{ entity.headquarterAddress.country }}</p>-->
<!--                            <p class='m-0 caption text-hint'>Pays</p>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </ng-container>-->
<!--        </div>-->

<!--        <div class='card mt-6'>-->
<!--            <div class='px-gutter py-4 border-b' fxLayout='row' fxLayoutAlign='space-between center'>-->
<!--                <h2 class='title m-0'>Adresses</h2>-->
<!--                <button color='primary' mat-raised-button type='button' (click)='createAddress()'-->
<!--                        *hasPermission="[ENUM_PERMISSION.UPDATE_SUPPLIER]">AJOUTER-->
<!--                </button>-->

<!--            </div>-->

<!--            <div @stagger-->
<!--                 class='px-gutter py-4'-->
<!--                 gdGap='24px'>-->
<!--                <base-data-table-->
<!--                        [showPaginator]='false'-->
<!--                        [sortField]='sortFieldAddress'-->
<!--                        [sortOrder]='sortOrderAddress'-->
<!--                        [dataSource]='dataSourceAddress'-->
<!--                        [displayedColumns]='displayedColumnsAddress'-->
<!--                        [feisColumns]='feisColumnsAddress'-->
<!--                        (onPageEvent)='pageEventAddress($event)'-->
<!--                        (onSortEvent)='sortEventAddress($event)'-->
<!--                        (onUpdateItem)='updateAddress($event)'-->
<!--                        (onDeleteItem)='deleteAddress($event)'-->
<!--                ></base-data-table>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->

<!--    <div class='flex-none max-w-unset md:max-w-xs w-full md:ltr:ml-6 md:rtl:mr-6 mt-6 md:mt-0'>-->
<!--        <div class='card'>-->
<!--            <div class='px-6 py-4 border-b flex flex-row justify-between'>-->
<!--                <div fxLayout='row' fxLayoutAlign='space-between center'>-->
<!--                    <h2 class='title m-0 mr-2'>Poste de dépense</h2>-->
<!--                </div>-->
<!--            </div>-->

<!--            <base-data-table-->
<!--                    [dataSource]='dataSourceFamille'-->
<!--                    [displayedColumns]='displayedColumnsFamille'-->
<!--                    [feisColumns]='feisColumnsFamille'-->
<!--                    [showPaginator]='false'-->
<!--                    [showSort]='false'-->
<!--                    (onUpdateItem)='updateItemFamille($event)'-->
<!--                    (onDeleteItem)='deleteItemFamille($event)'-->
<!--            ></base-data-table>-->
<!--        </div>-->
<!--    </div>-->

<!--    <ng-template #loading>-->
<!--        <div class='px-gutter py-4' gdColumns='1fr 1fr' gdColumns.xs='1fr' gdGap='16px'>-->
<!--            <div class='py-3' fxLayout='row' fxLayoutAlign='start center'>-->
<!--                <vex-skeleton class='w-14 mr-2' heigthTailwind='h-12' [circle]='true'></vex-skeleton>-->
<!--                <vex-skeleton class='w-full' heigthTailwind='h-12'></vex-skeleton>-->
<!--            </div>-->

<!--            <div class='py-3' fxLayout='row' fxLayoutAlign='start center'>-->
<!--                <vex-skeleton class='w-14 mr-2' heigthTailwind='h-12' [circle]='true'></vex-skeleton>-->
<!--                <vex-skeleton class='w-full' heigthTailwind='h-12'></vex-skeleton>-->
<!--            </div>-->

<!--            <div class='py-3' fxLayout='row' fxLayoutAlign='start center'>-->
<!--                <vex-skeleton class='w-14 mr-2' heigthTailwind='h-12' [circle]='true'></vex-skeleton>-->
<!--                <vex-skeleton class='w-full' heigthTailwind='h-12'></vex-skeleton>-->
<!--            </div>-->

<!--            <div class='py-3' fxLayout='row' fxLayoutAlign='start center'>-->
<!--                <vex-skeleton class='w-14 mr-2' heigthTailwind='h-12' [circle]='true'></vex-skeleton>-->
<!--                <vex-skeleton class='w-full' heigthTailwind='h-12'></vex-skeleton>-->
<!--            </div>-->

<!--            <div class='py-3' fxLayout='row' fxLayoutAlign='start center'>-->
<!--                <vex-skeleton class='w-14 mr-2' heigthTailwind='h-12' [circle]='true'></vex-skeleton>-->
<!--                <vex-skeleton class='w-full' heigthTailwind='h-12'></vex-skeleton>-->
<!--            </div>-->

<!--            <div class='py-3' fxLayout='row' fxLayoutAlign='start center'>-->
<!--                <vex-skeleton class='w-14 mr-2' heigthTailwind='h-12' [circle]='true'></vex-skeleton>-->
<!--                <vex-skeleton class='w-full' heigthTailwind='h-12'></vex-skeleton>-->
<!--            </div>-->
<!--        </div>-->
<!--    </ng-template>-->
<!--</div>-->

<div class="mt-6 flex flex-col md:flex-row md:items-start" *ngIf="supplierService.entity$ | async as entity">
  <div class="flex-auto">
    <!-- Détails Card -->
    <div class="card">
      <div class="px-gutter py-4 border-b flex justify-between items-center">
        <h2 class="title m-0">Détails</h2>
        <!-- Fournisseur interne : seul un isPredik peut le modifier (compte auxiliaire + familles d'achats, PRED-3210) -->
        <ng-container *ngIf="!isInternSupplier || isCurrentUserPredik">
          <button
            mat-raised-button
            color="primary"
            type="button"
            (click)="updateItem()"
            *hasPermission="[ENUM_PERMISSION.UPDATE_SUPPLIER]"
          >
            MODIFIER
          </button>
        </ng-container>
      </div>

      <ng-template #loading>
        <!-- Skeleton loader here -->
      </ng-template>

      <div *ngIf="entity._id; else loading" class="px-gutter py-4 grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- Nom et Type -->
        <div class="py-3 flex items-center">
          <div @fadeInRight>
            <p class="m-0 body-1">{{ entity.label }}</p>
            <p class="m-0 caption text-hint">Dénomination</p>
          </div>
        </div>

        <!-- Nom commercial issu de l'API Recherche d'Entreprises (PRED-3215) -->
        <div class="py-3 flex items-center" *ngIf="entity.commercialName">
          <div @fadeInRight>
            <p class="m-0 body-1">{{ entity.commercialName }}</p>
            <p class="m-0 caption text-hint">Nom commercial</p>
          </div>
        </div>

        <div class="py-3 flex items-center">
          <div @fadeInRight>
            <p class="m-0 body-1">{{ entity.type | titlecase }}</p>
            <p class="m-0 caption text-hint">Type</p>
          </div>
        </div>

        <ng-container [ngSwitch]="entity.type">
          <!-- Fournisseur Externe -->
          <ng-container *ngSwitchCase="SupplierType.EXTERNE">
            <div class="py-3 flex items-center">
              <div @fadeInRight>
                <p class="m-0 body-1">{{ entity.tva }}</p>
                <p class="m-0 caption text-hint">Numéro de TVA</p>
              </div>
            </div>

            <details-line-base [label]="entity.subsidiarAccount" hint="Compte auxiliaire comptable"></details-line-base>

            <ng-container *ngIf="entity.headquarterAddress?.country !== 'France'">
              <div class="py-3 flex items-center">
                <div @fadeInRight>
                  <p class="m-0 body-1">{{ entity.dunsNumber }}</p>
                  <p class="m-0 caption text-hint">Identifiant entreprise</p>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="entity.headquarterAddress?.country === 'France'">
              <div class="py-3 flex items-center">
                <div @fadeInRight>
                  <p class="m-0 body-1">{{ entity.siretNumber }}</p>
                  <p class="m-0 caption text-hint">Numéro de siret</p>
                </div>
              </div>

              <div class="py-3 flex items-center">
                <div @fadeInRight>
                  <p class="m-0 body-1">{{ entity.sirenNumber }}</p>
                  <p class="m-0 caption text-hint">Numéro de siren</p>
                </div>
              </div>

              <div class="py-3 flex items-center">
                <div @fadeInRight>
                  <p class="m-0 body-1">{{ entity.codeApe }}</p>
                  <p class="m-0 caption text-hint">Code APE</p>
                </div>
              </div>

              <ng-container *ngIf="entity.supportEstablishment">
                <div class="py-3 flex items-center">
                  <details-line-base
                    hint="Établissement support lié"
                    [label]="entity.supportEstablishment.technicalIdentifier"
                    [linkPermission]="ENUM_PERMISSION.READ_SUPPLIER"
                    [link]="'/management/establishment/' + entity.supportEstablishment._id"
                  ></details-line-base>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>

          <!-- Fournisseur Interne -->
          <ng-container *ngSwitchCase="SupplierType.INTERNE">
            <ng-container *ngIf="entity.supportEstablishment; else noSupport">
              <div class="py-3 flex items-center">
                <details-line-base
                  hint="Établissement support lié"
                  [label]="entity.supportEstablishment.technicalIdentifier"
                  [linkPermission]="ENUM_PERMISSION.READ_SUPPLIER"
                  [link]="'/management/establishment/' + entity.supportEstablishment._id"
                ></details-line-base>
              </div>

              <details-line-base
                *ngIf="supportEstablishment?.sirenNumber"
                hint="N° Siren"
                [label]="supportEstablishment.sirenNumber"
              ></details-line-base>

              <details-line-base
                *ngIf="supportEstablishment?.dunsNumber"
                hint="Identifiant entreprise"
                [label]="supportEstablishment.dunsNumber"
              ></details-line-base>

              <details-line-base
                *ngIf="supportEstablishment?.tva"
                hint="Numéro de TVA"
                [label]="supportEstablishment.tva"
              ></details-line-base>

              <details-line-base
                hint="Compte auxiliaire comptable"
                [label]="entity.subsidiarAccount ? entity.subsidiarAccount : 'N/A'"
              ></details-line-base>

              <details-line-base hint="Code APE" [label]="supportEstablishment.ape"></details-line-base>

              <details-line-base
                hint="Comptable de rattachement"
                [label]="
                  supportEstablishment?.attachedAccountant
                    ? supportEstablishment.attachedAccountant.firstName +
                      ' ' +
                      supportEstablishment.attachedAccountant.lastName
                    : 'N/A'
                "
              ></details-line-base>

              <details-line-base
                hint="Dossier comptable"
                [label]="supportEstablishment?.accountingFile ? supportEstablishment.accountingFile : 'N/A'"
              ></details-line-base>

              <details-line-base
                hint="Statut TVA"
                [label]="supportEstablishment?.vatStatus ? 'Soumis' : 'Non soumis'"
              ></details-line-base>
            </ng-container>
            <ng-template #noSupport>
              <!-- Aucun établissement support pour ce fournisseur interne -->
            </ng-template>
          </ng-container>

          <!-- Fournisseur Particulier : pas d'identifiant (SIRET / APE / TVA), uniquement le compte auxiliaire -->
          <ng-container *ngSwitchCase="SupplierType.PARTICULIER">
            <details-line-base [label]="entity.subsidiarAccount" hint="Compte auxiliaire comptable"></details-line-base>
          </ng-container>

          <!-- Fournisseur Étranger : compte auxiliaire + identifiant entreprise (dunsNumber) -->
          <ng-container *ngSwitchCase="SupplierType.ETRANGER">
            <details-line-base [label]="entity.subsidiarAccount" hint="Compte auxiliaire comptable"></details-line-base>

            <div class="py-3 flex items-center">
              <div @fadeInRight>
                <p class="m-0 body-1">{{ entity.dunsNumber }}</p>
                <p class="m-0 caption text-hint">Identifiant entreprise</p>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <!-- Traitement facture PA/PREDIK360 (PRED-3268) : après les identifiants (Code APE), hors fournisseur interne -->
        <details-line-base
          *ngIf="entity.type !== SupplierType.INTERNE"
          [hint]="ELECTRONIC_INVOICE_FIELD_LABEL"
          [label]="entity.electronicInvoicePlatform ? 'Conforme' : 'Non conforme'"
        ></details-line-base>
      </div>

      <!-- Adresse fournisseur (Externe / Particulier / Étranger) : restituée dans la même section pour tous ces types -->
      <ng-container
        *ngIf="
          entity.type === SupplierType.EXTERNE ||
          entity.type === SupplierType.PARTICULIER ||
          entity.type === SupplierType.ETRANGER
        "
      >
        <div class="px-gutter py-4 border-b flex justify-between items-center">
          <h2 class="title m-0">Adresse fournisseur</h2>
        </div>

        <div *ngIf="entity._id; else loading" class="px-gutter py-4 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="py-3 flex items-center">
            <div @fadeInRight>
              <p class="m-0 body-1">{{ entity.headquarterAddress?.street }}</p>
              <p class="m-0 caption text-hint">Adresse</p>
            </div>
          </div>
          <div class="py-3 flex items-center">
            <div @fadeInRight>
              <p class="m-0 body-1">{{ entity.headquarterAddress?.additionalAddress }}</p>
              <p class="m-0 caption text-hint">Complément d'adresse</p>
            </div>
          </div>
          <div class="py-3 flex items-center">
            <div @fadeInRight>
              <p class="m-0 body-1">{{ entity.headquarterAddress?.postalCode }}</p>
              <p class="m-0 caption text-hint">Code postal</p>
            </div>
          </div>
          <div class="py-3 flex items-center">
            <div @fadeInRight>
              <p class="m-0 body-1">{{ entity.headquarterAddress?.city }}</p>
              <p class="m-0 caption text-hint">Ville</p>
            </div>
          </div>
          <div class="py-3 flex items-center">
            <div @fadeInRight>
              <p class="m-0 body-1">{{ entity.headquarterAddress?.country }}</p>
              <p class="m-0 caption text-hint">Pays</p>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="entity.type === SupplierType.INTERNE && entity.supportEstablishment">
        <div class="px-gutter py-4 border-b flex justify-between items-center">
          <h2 class="title m-0">Adresse principale de l'établissement</h2>
        </div>

        <div class="px-gutter py-4">
          <details-line-base
            *ngIf="supportEstablishment?.mainAddressData"
            hint="Adresse principale"
            [label]="supportEstablishment.mainAddressData | formatAddress"
          ></details-line-base>

          <details-line-base
            *ngIf="supportEstablishment?.billingAddressData"
            hint="Adresse de facturation"
            [label]="supportEstablishment.billingAddressData | formatAddress"
          ></details-line-base>
        </div>
      </ng-container>
    </div>
    <ng-container *ngIf="!isInternSupplier">
      <!-- Adresses secondaires -->
      <div class="card mt-6">
        <div class="px-gutter py-4 border-b flex justify-between items-center">
          <h2 class="title m-0">Adresses</h2>

          <button
            mat-raised-button
            color="primary"
            type="button"
            (click)="createAddress()"
            *hasPermission="[ENUM_PERMISSION.UPDATE_SUPPLIER]"
          >
            AJOUTER
          </button>
        </div>

        <div @stagger class="px-gutter py-4" gdGap="24px">
          <base-data-table
            [showPaginator]="false"
            [sortField]="sortFieldAddress"
            [sortOrder]="sortOrderAddress"
            [dataSource]="dataSourceAddress"
            [displayedColumns]="displayedColumnsAddress"
            [feisColumns]="feisColumnsAddress"
            (onPageEvent)="pageEventAddress($event)"
            (onSortEvent)="sortEventAddress($event)"
            (onUpdateItem)="updateAddress($event)"
            (onDeleteItem)="deleteAddress($event)"
          ></base-data-table>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Poste de dépense Sidebar -->
  <div class="flex-none w-full md:max-w-xs md:ltr:ml-6 md:rtl:mr-6 mt-6 md:mt-0">
    <div class="card">
      <div class="px-6 py-4 border-b flex justify-between items-center">
        <h2 class="title m-0 mr-2">Poste de dépense</h2>
      </div>

      <base-data-table
        [dataSource]="dataSourceFamille"
        [displayedColumns]="displayedColumnsFamille"
        [feisColumns]="feisColumnsFamille"
        [showPaginator]="false"
        [showSort]="false"
        (onUpdateItem)="updateItemFamille($event)"
        (onDeleteItem)="deleteItemFamille($event)"
      ></base-data-table>
    </div>
  </div>
</div>
